import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-047bae8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colFirst" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-3 ModelField-colFirst" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_8 = { class: "col-3 ModelField-col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_10 = { class: "col-3 ModelField-col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_12 = { class: "col-3 ModelField-colLast" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота двери (мм)", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-3 ModelField-colFirst" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_17 = { class: "col-3 ModelField-col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Кубатура (объем)", -1))
const _hoisted_19 = { class: "col-3 ModelField-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Предел веса ТС (кг)", -1))
const _hoisted_21 = { class: "col-3 ModelField-colLast" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_23 = { class: "card card-body Container-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title Container-title" }, " Данные для расчета допустимого смещения ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Допускаемое смещение общего ЦТ груза в транспорте ", -1))
const _hoisted_26 = { class: "container-fluid" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-6 ModelField-colFirst" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вес порожнего транспортного средства (кг) ", -1))
const _hoisted_30 = { class: "col-6 ModelField-colLast" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота ЦТ порожнего транспортного средства (мм) ", -1))
const _hoisted_32 = { class: "TransportContainerCreateEditDialog_subTableFirstColumn" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Реквизиты", -1))
const _hoisted_34 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    maxWidth: "1000px",
    onOnShown: _ctx.onShown,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Длина...",
                min: 0,
                value: model.length,
                "onUpdate:value": ($event: any) => ((model.length) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Ширина...",
                min: 0,
                value: model.width,
                "onUpdate:value": ($event: any) => ((model.width) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота...",
                min: 0,
                value: model.height,
                "onUpdate:value": ($event: any) => ((model.height) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота двери...",
                min: 0,
                value: model.doorHeight,
                "onUpdate:value": ($event: any) => ((model.doorHeight) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Грузоподъемность...",
                decimalPoints: 2,
                min: 0,
                value: model.loadCapacity,
                "onUpdate:value": ($event: any) => ((model.loadCapacity) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Кубатура...",
                decimalPoints: 2,
                min: 0,
                value: model.volume,
                "onUpdate:value": ($event: any) => ((model.volume) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Предел веса ТС...",
                decimalPoints: 2,
                min: 0,
                value: model.weightLimitVehicle,
                "onUpdate:value": ($event: any) => ((model.weightLimitVehicle) = $event),
                hasEmptyValue: true,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.gapId,
                "onUpdate:id": ($event: any) => ((model.gapId) = $event),
                desc: model.gapDescription,
                "onUpdate:desc": ($event: any) => ((model.gapDescription) = $event),
                displayDescField: "name",
                keyField: "id",
                catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", null, [
              _hoisted_25,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.displacementId,
                "onUpdate:id": ($event: any) => ((model.displacementId) = $event),
                desc: model.displacementDescription,
                "onUpdate:desc": ($event: any) => ((model.displacementDescription) = $event),
                displayDescField: "name",
                keyField: "id",
                catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_DecimalControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Вес порожнего ТС...",
                    decimalPoints: 2,
                    min: 0,
                    value: model.weight,
                    "onUpdate:value": ($event: any) => ((model.weight) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_IntegerControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Высота ЦТ порожнего ТС...",
                    min: 0,
                    value: model.heightCenterMass,
                    "onUpdate:value": ($event: any) => ((model.heightCenterMass) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", {
            class: "TransportContainerCreateEditDialog_requisiteSubGrid",
            id: _ctx.requisiteSubGridDomId
          }, null, 8, _hoisted_34)
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}